import { render, staticRenderFns } from "./ProductBagSummary.vue?vue&type=template&id=194162d1&scoped=true&"
import script from "./ProductBagSummary.vue?vue&type=script&lang=js&"
export * from "./ProductBagSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194162d1",
  null
  
)

export default component.exports